/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ВНИМАНИЕ! Когда сюда что-то добавляете проверьте все места где исопльзуется существующее какое-то значение и добавьте туда обработку нового
 * @export
 * @enum {string}
 */
export enum FxIdDomainStoreEnumsSupportedWebPublishingPlatform {
    FxId = 0,
    VkontaktePlay = 1,
    Odnoklassniki = 2,
    VkontakteCom = 3,
    YandexGames = 4,
    AbsoluteGames = 5,
    Kongregate = 6,
    FacebookGames = 7,
    CrazyGames = 8,
    WizQ = 9,
    Telegram = 10,
    FxLauncher = 11,
    FxNative = 12,
    Steam = 13,
    FacebookInstantGames = 14,
    Unspecified = -1,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainStoreEnumsSupportedWebPublishingPlatform(value: any): boolean {
    for (const key in FxIdDomainStoreEnumsSupportedWebPublishingPlatform) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainStoreEnumsSupportedWebPublishingPlatform, key)) {
            if (FxIdDomainStoreEnumsSupportedWebPublishingPlatform[key as keyof typeof FxIdDomainStoreEnumsSupportedWebPublishingPlatform] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSON(json: any): FxIdDomainStoreEnumsSupportedWebPublishingPlatform {
    return FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSONTyped(json, false);
}

export function FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainStoreEnumsSupportedWebPublishingPlatform {
    return json as FxIdDomainStoreEnumsSupportedWebPublishingPlatform;
}

export function FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON(value?: FxIdDomainStoreEnumsSupportedWebPublishingPlatform | null): any {
    return value as any;
}

export function FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainStoreEnumsSupportedWebPublishingPlatform {
    return value as FxIdDomainStoreEnumsSupportedWebPublishingPlatform;
}

